
import { toString as toString_1, Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, lambda_type, unit_type, union_type, array_type, list_type, class_type, option_type, anonRecord_type, bool_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState__getValidation, FormState__setValidationResponse_5219762A, ProcedureId, ProcedureTemplateId, FormState__startLoading, AssignToolWithoutNotificationDto, ToolId as ToolId_1, RequestedValue$1, FormState_get_empty, ProcedureId_$reflection, RequestedValue$1_$reflection, FormState_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { Helper_receiverTypeNameTranslation, ReceiverTypeName, Receiver_$reflection } from "../../Shared/User.js";
import { DTO_CreateProcedureDto_$reflection, DTO_CreateProcedureDto, DTO_GetSenderHooksRequest_$reflection, DTO_GetSenderHooksRequest, DTO_SenderHookDto_$reflection, DTO_AssignmentHookDto_$reflection } from "../../Shared/Procedure.js";
import { ImageUpload, DnDFormImage, DnDFormImage_$reflection } from "../../Widgets/Image/ImageUploadDnD.js";
import { FileUploadResponse_$reflection } from "../../Shared/File.js";
import { AssignToolNotification, ProcedureTemplateSelection, ToolDetailDto_$reflection } from "../../Shared/Tool.js";
import { sortBy, toArray, isEmpty, max, tryPick, sumBy, append, filter, choose, exists, singleton, empty, ofArray, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { add, contains, empty as empty_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Set.js";
import { safeHash, equals, createObj, stringHash, comparePrimitives } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Cmd_ofEffect, Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { printf, toText, join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { unwrap, map as map_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { toISOString } from "../../Common.js";
import { Cmd_assignCmd, Cmd_assignWithNotificationCmd } from "../../Requests/Tool.js";
import { List_groupBy, List_distinctBy } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { uploadImage } from "../../Requests/Files.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { empty as empty_2, append as append_1, singleton as singleton_1, collect, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import Check_Circle from "../../../public/assets/icons/Check_Circle.svg";
import { TextButton } from "../../Components/Button.js";
import { utcNow, date } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { ToolInfo } from "../../Widgets/ToolInfoWidget.js";
import { MultiSelect, GroupedSelect } from "../../Components/Select.js";
import { TextArea } from "../../Components/TextArea.js";
import { Checkbox } from "../../Components/Checkbox.js";
import { ErrorAlert, InformationAlert } from "../../Components/Alert.js";
import { DatePicker } from "../../Components/DatePicker.js";
import { TextValue } from "../../Components/Text.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { OpenProcedureModal } from "../../Widgets/Procedure/Form/View.js";
import { Dialog } from "../../Components/Dialog.js";
import { Skeleton } from "../../Components/Skeleton.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AssignedToolResponse", "OnAssignTool", "SetWithNotification", "SetWithSignature", "SetComment", "SetSelectedUser", "SetDate", "ReceiversFetched", "AssignmentHooksFetched", "SetSelectedProcedureTemplates", "SenderHooksFetched", "StartSenderProcedure", "ContinueSenderProcedure", "SenderProcedureCreated", "SenderProcedureCompleted", "CloseProcedureModal", "FetchError", "SetSelectedSenderFiles", "SenderImageUploaded"];
    }
}

function Msg_$reflection() {
    return union_type("Tools.AssignToolDialog.Msg", [], Msg, () => [[["Item", ClientApiResponse$1_$reflection(string_type)]], [], [["Item", bool_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", Receiver_$reflection()]))]], [["Item", option_type(class_type("System.DateTime"))]], [["Item", list_type(Receiver_$reflection())]], [["Item", ClientApiResponse$1_$reflection(list_type(DTO_AssignmentHookDto_$reflection()))]], [["Item", option_type(array_type(anonRecord_type(["label", string_type], ["value", DTO_AssignmentHookDto_$reflection()])))]], [["Item", ClientApiResponse$1_$reflection(list_type(DTO_SenderHookDto_$reflection()))]], [["Item", DTO_SenderHookDto_$reflection()]], [["procedureId", class_type("System.Guid")], ["templateId", class_type("System.Guid")]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [], [], [["Item", class_type("System.Exception")]], [["Item", list_type(DnDFormImage_$reflection())]], [["Item", FileUploadResponse_$reflection()]]]);
}

class State extends Record {
    constructor(Tool, Comment$, UserId, FormState, SuccessCallback, SelectedUser, Date$, WithNotification, WithSignature, OnClose, Receivers, AssignmentHooks, SelectedProcedureTemplates, SenderHooks, ActiveProcedureId, ActiveProcedureTemplateId, CompletedSenderHookTemplateIds, SenderImageFiles, ImageUploading) {
        super();
        this.Tool = Tool;
        this.Comment = Comment$;
        this.UserId = UserId;
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.SelectedUser = SelectedUser;
        this.Date = Date$;
        this.WithNotification = WithNotification;
        this.WithSignature = WithSignature;
        this.OnClose = OnClose;
        this.Receivers = Receivers;
        this.AssignmentHooks = AssignmentHooks;
        this.SelectedProcedureTemplates = SelectedProcedureTemplates;
        this.SenderHooks = SenderHooks;
        this.ActiveProcedureId = ActiveProcedureId;
        this.ActiveProcedureTemplateId = ActiveProcedureTemplateId;
        this.CompletedSenderHookTemplateIds = CompletedSenderHookTemplateIds;
        this.SenderImageFiles = SenderImageFiles;
        this.ImageUploading = ImageUploading;
    }
}

function State_$reflection() {
    return record_type("Tools.AssignToolDialog.State", [], State, () => [["Tool", ToolDetailDto_$reflection()], ["Comment", string_type], ["UserId", string_type], ["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["SelectedUser", option_type(anonRecord_type(["label", string_type], ["value", Receiver_$reflection()]))], ["Date", option_type(class_type("System.DateTime"))], ["WithNotification", bool_type], ["WithSignature", bool_type], ["OnClose", lambda_type(unit_type, unit_type)], ["Receivers", RequestedValue$1_$reflection(list_type(Receiver_$reflection()))], ["AssignmentHooks", RequestedValue$1_$reflection(list_type(DTO_AssignmentHookDto_$reflection()))], ["SelectedProcedureTemplates", list_type(anonRecord_type(["label", string_type], ["value", DTO_AssignmentHookDto_$reflection()]))], ["SenderHooks", RequestedValue$1_$reflection(list_type(DTO_SenderHookDto_$reflection()))], ["ActiveProcedureId", option_type(ProcedureId_$reflection())], ["ActiveProcedureTemplateId", option_type(class_type("System.Guid"))], ["CompletedSenderHookTemplateIds", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [class_type("System.Guid")])], ["SenderImageFiles", list_type(DnDFormImage_$reflection())], ["ImageUploading", bool_type]]);
}

const maxSenderImages = 5;

function fetchSenderHooksCmd(tool) {
    const request = new DTO_GetSenderHooksRequest(map((c) => parse(c.CategoryId), tool.Categories), tool.Id);
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(DTO_SenderHookDto_$reflection())));
        }, refreshOn)))(true);
    })), ["/api/procedure-templates/hooks/assignment-sender", toString(0, Auto_generateBoxedEncoder_437914C6(DTO_GetSenderHooksRequest_$reflection(), undefined, undefined, undefined)(request))], (Item) => (new Msg(10, [Item])), (Item_1) => (new Msg(16, [Item_1])));
}

function init(tool, userId, successCallback, onClose) {
    let businessUnitId;
    const labelIds = map((c) => parse(c.CategoryId), tool.Categories);
    return [new State(tool, "", userId, FormState_get_empty(), successCallback, undefined, undefined, false, false, onClose, new RequestedValue$1(0, []), new RequestedValue$1(0, []), empty(), new RequestedValue$1(0, []), undefined, undefined, empty_1({
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }), empty(), false), Cmd_batch(ofArray([(businessUnitId = tool.BusinessUnitId, Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(Receiver_$reflection())));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), concat("/api/receivers/active", ...((businessUnitId == null) ? "?businessUnitId=" : concat("?businessUnitId=", ...businessUnitId))), (Item) => (new Msg(7, [Item])), (Item_1) => (new Msg(16, [Item_1])))), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_5;
        return ((url_5 = addPrefix(tupledArg[0]), (refreshOn_1) => fetchWithDecoder(url_5, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response_1) => {
            const pr_1 = response_1.arrayBuffer();
            return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(DTO_AssignmentHookDto_$reflection())));
        }, refreshOn_1)))(true);
    })), ["/api/procedure-templates/hooks/assignment", toString(0, Auto_generateBoxedEncoder_437914C6(list_type(class_type("System.Guid")), undefined, undefined, undefined)(labelIds))], (Item_2) => (new Msg(8, [Item_2])), (Item_3) => (new Msg(16, [Item_3]))), fetchSenderHooksCmd(tool)]))];
}

function hasMandatoryUncompletedSenderHooks(senderHooks, completedIds) {
    if (senderHooks.tag === 0) {
        return true;
    }
    else {
        return exists((h) => {
            if (h.IsMandatory) {
                return !contains(h.ProcedureTemplateId, completedIds);
            }
            else {
                return false;
            }
        }, senderHooks.fields[0]);
    }
}

function update(msg, state) {
    let matchValue_4, body, matchValue_5, file_1;
    switch (msg.tag) {
        case 1: {
            const matchValue_1 = state.SelectedUser;
            let matchResult, receiver;
            if (state.Tool.AssignedReceiverInformation != null) {
                if (matchValue_1 != null) {
                    matchResult = 1;
                }
                else {
                    matchResult = 1;
                }
            }
            else if (matchValue_1 == null) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                receiver = matchValue_1;
            }
            switch (matchResult) {
                case 0: {
                    const senderImageUrls = choose((f) => {
                        if (f.tag === 1) {
                            return f.fields[0].ImageUrl;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles);
                    let command;
                    if (state.WithNotification) {
                        const procedureTemplates = map((h) => (new ProcedureTemplateSelection(h.value.ProcedureTemplateId, h.value.ProcedureTemplateName)), state.SelectedProcedureTemplates);
                        const dto = new AssignToolNotification(receiver.value.Id, state.Comment, "storageToUser", state.WithSignature, map_1(toISOString, state.Date), procedureTemplates, senderImageUrls);
                        command = Cmd_assignWithNotificationCmd(new ToolId_1(parse(state.Tool.Id)), dto, (Item_1) => (new Msg(0, [Item_1])), (Item_2) => (new Msg(16, [Item_2])));
                    }
                    else {
                        const dto_1 = new AssignToolWithoutNotificationDto(receiver.value.Id, state.Comment, undefined, map_1(toISOString, state.Date), senderImageUrls);
                        command = Cmd_assignCmd(new ToolId_1(parse(state.Tool.Id)), dto_1, (Item_4) => (new Msg(0, [Item_4])), (Item_5) => (new Msg(16, [Item_5])));
                    }
                    return [new State(state.Tool, state.Comment, state.UserId, FormState__startLoading(state.FormState), state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), command];
                }
                default:
                    return [state, Cmd_none()];
            }
        }
        case 2: {
            const withNotification = msg.fields[0];
            if (!withNotification) {
                return [new State(state.Tool, state.Comment, state.UserId, state.FormState, state.SuccessCallback, state.SelectedUser, state.Date, withNotification, false, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
            else {
                return [new State(state.Tool, state.Comment, state.UserId, state.FormState, state.SuccessCallback, state.SelectedUser, state.Date, withNotification, state.WithSignature, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
        }
        case 3: {
            const withSignature = msg.fields[0];
            if (withSignature) {
                return [new State(state.Tool, state.Comment, state.UserId, state.FormState, state.SuccessCallback, state.SelectedUser, state.Date, true, withSignature, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
            else {
                return [new State(state.Tool, state.Comment, state.UserId, state.FormState, state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, withSignature, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
        }
        case 4:
            return [new State(state.Tool, msg.fields[0], state.UserId, state.FormState, state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 5:
            return [new State(state.Tool, state.Comment, state.UserId, state.FormState, state.SuccessCallback, msg.fields[0], state.Date, state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 6:
            return [new State(state.Tool, state.Comment, state.UserId, state.FormState, state.SuccessCallback, state.SelectedUser, msg.fields[0], state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 7:
            return [new State(state.Tool, state.Comment, state.UserId, state.FormState, state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, state.WithSignature, state.OnClose, new RequestedValue$1(1, [msg.fields[0]]), state.AssignmentHooks, state.SelectedProcedureTemplates, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 8: {
            const response_2 = msg.fields[0];
            if (response_2.tag === 1) {
                return [new State(state.Tool, state.Comment, state.UserId, state.FormState, state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, new RequestedValue$1(1, [empty()]), state.SelectedProcedureTemplates, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
            else {
                const hooks = response_2.fields[0];
                return [new State(state.Tool, state.Comment, state.UserId, state.FormState, state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, new RequestedValue$1(1, [hooks]), map((h_2) => ({
                    label: h_2.ProcedureTemplateName,
                    value: h_2,
                }), filter((h_1) => h_1.IsMandatory, hooks)), state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
        }
        case 9: {
            const selectedTemplates = msg.fields[0];
            if (selectedTemplates == null) {
                return [new State(state.Tool, state.Comment, state.UserId, state.FormState, state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, state.AssignmentHooks, (matchValue_4 = state.AssignmentHooks, (matchValue_4.tag === 1) ? map((h_6) => ({
                    label: h_6.ProcedureTemplateName,
                    value: h_6,
                }), filter((h_5) => h_5.IsMandatory, matchValue_4.fields[0])) : empty()), state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
            else {
                const templates = selectedTemplates;
                let mandatoryTemplates_1;
                const matchValue_3 = state.AssignmentHooks;
                mandatoryTemplates_1 = ((matchValue_3.tag === 1) ? map((h_4) => ({
                    label: h_4.ProcedureTemplateName,
                    value: h_4,
                }), filter((h_3) => h_3.IsMandatory, matchValue_3.fields[0])) : empty());
                return [new State(state.Tool, state.Comment, state.UserId, state.FormState, state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, state.AssignmentHooks, List_distinctBy((t) => t.value.ProcedureTemplateId, append(ofArray(templates), mandatoryTemplates_1), {
                    Equals: (x, y) => (x === y),
                    GetHashCode: (x) => (stringHash(x) | 0),
                }), state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
        }
        case 10: {
            const response_3 = msg.fields[0];
            if (response_3.tag === 1) {
                return [new State(state.Tool, state.Comment, state.UserId, state.FormState, state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, new RequestedValue$1(1, [empty()]), state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
            else {
                return [new State(state.Tool, state.Comment, state.UserId, state.FormState, state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, new RequestedValue$1(1, [response_3.fields[0]]), state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
        }
        case 11: {
            const hook = msg.fields[0];
            const dto_2 = new DTO_CreateProcedureDto(state.Tool.Id);
            return [new State(state.Tool, state.Comment, state.UserId, FormState__startLoading(state.FormState), state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, state.SenderHooks, state.ActiveProcedureId, hook.ProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), (body = toString(0, Auto_generateBoxedEncoder_437914C6(DTO_CreateProcedureDto_$reflection(), undefined, undefined, undefined)(dto_2)), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response_4) => {
                    const pr = response_4.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                }, refreshOn)))(true);
            })), [concat("/api/procedure-templates/", toString_1(new ProcedureTemplateId(hook.ProcedureTemplateId)), ..."/procedure"), body], (Item_6) => (new Msg(13, [Item_6])), (Item_7) => (new Msg(16, [Item_7]))))];
        }
        case 12:
            return [new State(state.Tool, state.Comment, state.UserId, state.FormState, state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, state.SenderHooks, new ProcedureId(msg.fields[0]), msg.fields[1], state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 13: {
            const response_5 = msg.fields[0];
            if (response_5.tag === 1) {
                return [new State(state.Tool, state.Comment, state.UserId, FormState__setValidationResponse_5219762A(state.FormState, response_5.fields[0]), state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.Tool, state.Comment, state.UserId, FormState_get_empty(), state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, state.SenderHooks, new ProcedureId(parse(response_5.fields[0])), state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
        }
        case 14:
            return [new State(state.Tool, state.Comment, state.UserId, state.FormState, state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, state.SenderHooks, undefined, undefined, (matchValue_5 = state.ActiveProcedureTemplateId, (matchValue_5 == null) ? state.CompletedSenderHookTemplateIds : add(matchValue_5, state.CompletedSenderHookTemplateIds)), state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 15:
            return [new State(state.Tool, state.Comment, state.UserId, state.FormState, state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, state.SenderHooks, undefined, undefined, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), fetchSenderHooksCmd(state.Tool)];
        case 16:
            return [new State(state.Tool, state.Comment, state.UserId, state.FormState, state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, false), Cmd_none()];
        case 17: {
            const newFiles = msg.fields[0];
            const alreadyUploadedCount = sumBy((f_1) => {
                if (f_1.tag === 1) {
                    return 1;
                }
                else {
                    return 0;
                }
            }, state.SenderImageFiles, {
                GetZero: () => 0,
                Add: (x_2, y_1) => ((x_2 + y_1) | 0),
            }) | 0;
            const pickedFile = tryPick((f_2) => {
                if (f_2.tag === 0) {
                    return f_2.fields[0].File;
                }
                else {
                    return undefined;
                }
            }, newFiles);
            let matchResult_1, file_2;
            if (pickedFile != null) {
                if ((file_1 = pickedFile, alreadyUploadedCount < maxSenderImages)) {
                    matchResult_1 = 0;
                    file_2 = pickedFile;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    const formData = new FormData();
                    formData.append(file_2.name, file_2);
                    return [new State(state.Tool, state.Comment, state.UserId, state.FormState, state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, newFiles, true), uploadImage((Item_10) => (new Msg(18, [Item_10])), (Item_11) => (new Msg(16, [Item_11])), formData)];
                }
                default:
                    return [new State(state.Tool, state.Comment, state.UserId, state.FormState, state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, newFiles, state.ImageUploading), Cmd_none()];
            }
        }
        case 18: {
            const response_6 = msg.fields[0];
            switch (response_6.tag) {
                case 0:
                    return [new State(state.Tool, state.Comment, state.UserId, state.FormState, state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, filter((f_5) => {
                        if (f_5.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false), Cmd_errorToast("general.file_too_large")];
                case 2:
                    return [new State(state.Tool, state.Comment, state.UserId, state.FormState, state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, filter((f_6) => {
                        if (f_6.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false), Cmd_errorToast("general.a_error_occured")];
                default: {
                    const nextPosition = (1 + max(append(singleton(0), choose((f_3) => {
                        if (f_3.tag === 1) {
                            return f_3.fields[0].Position;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles)), {
                        Compare: (x_3, y_2) => (comparePrimitives(x_3, y_2) | 0),
                    })) | 0;
                    return [new State(state.Tool, state.Comment, state.UserId, state.FormState, state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, append(choose((f_4) => {
                        if (f_4.tag === 1) {
                            return f_4;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles), singleton(new DnDFormImage(1, [{
                        ImageUrl: response_6.fields[0].ImageUrl,
                        Position: nextPosition,
                    }]))), false), Cmd_none()];
                }
            }
        }
        default: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(state.Tool, state.Comment, state.UserId, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.Tool, state.Comment, state.UserId, FormState_get_empty(), state.SuccessCallback, state.SelectedUser, state.Date, state.WithNotification, state.WithSignature, state.OnClose, state.Receivers, state.AssignmentHooks, state.SelectedProcedureTemplates, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
    }
}

function SenderHooksSection(props) {
    let elems_4, elems_3;
    const patternInput = useTranslation();
    if (isEmpty(props.SenderHooks)) {
        return defaultOf();
    }
    else {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_4 = [reactElement("div", {
            className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
            children: patternInput[0](props.TitleKey),
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_3 = toList(delay(() => collect((hook) => {
            let elems_2;
            const isCompleted = contains(hook.ProcedureTemplateId, props.CompletedSenderHookTemplateIds);
            return singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "gap-2"])], (elems_2 = toList(delay(() => {
                let children;
                return append_1(singleton_1((children = toList(delay(() => {
                    let elems, elems_1;
                    return isCompleted ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5", "text-green"])], (elems = [Check_Circle()], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5", "text-border"])], (elems_1 = [Check_Circle()], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
                })), reactElement("div", {
                    children: reactApi.Children.toArray(Array.from(children)),
                }))), delay(() => (isCompleted ? singleton_1(reactElement("span", {
                    className: join(" ", ["text-sm"]),
                    children: hook.ProcedureTemplateName,
                })) : singleton_1(createElement(TextButton, {
                    ComponentState: props.FormState.IsLoading ? "disabled" : "enabled",
                    Label: hook.ProcedureTemplateName,
                    OnClick: () => {
                        const matchValue = hook.ProcedureId;
                        if (matchValue == null) {
                            props.Dispatch(new Msg(11, [hook]));
                        }
                        else {
                            props.Dispatch(new Msg(12, [matchValue, hook.ProcedureTemplateId]));
                        }
                    },
                    TestId: `sender-procedure-${hook.ProcedureTemplateId}`,
                    Variant: "blueButton",
                })))));
            })), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
        }, props.SenderHooks))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
    }
}

function DialogBody(props) {
    let elems_3;
    const t = useTranslation()[0];
    const today = date(utcNow());
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["id", "assign-tool-dialog"], ["className", join(" ", ["grid", "gap-5"])], (elems_3 = toList(delay(() => {
        let elems;
        return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(ToolInfo, {
            DisplayReservationAlert: true,
            ToolId: new ToolId_1(parse(props.Tool.Id)),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append_1(singleton_1(createElement(GroupedSelect, (($value) => { $value.key = $value.Key; return $value; })({
            ComponentState: componentState,
            IsClearable: false,
            Key: "assign-tool-select",
            Label: t("tool.assign_tool"),
            NoOptionsMessage: "select.employee_no_options",
            OnChange: (arg) => {
                props.Dispatch(new Msg(5, [arg]));
            },
            Options: map((tupledArg) => {
                const receiverType = tupledArg[0];
                const receivers_1 = toArray(sortBy((receiver_2) => receiver_2.label.toLowerCase(), map((receiver_1) => {
                    const matchValue_1 = receiver_1.LocationName;
                    if (matchValue_1 != null) {
                        const locationName = matchValue_1;
                        if (equals(receiverType, new ReceiverTypeName(4, []))) {
                            return {
                                label: concat(locationName, " - ", ...receiver_1.Name),
                                value: receiver_1,
                            };
                        }
                        else {
                            return {
                                label: concat(receiver_1.Name, " - ", ...locationName),
                                value: receiver_1,
                            };
                        }
                    }
                    else {
                        return {
                            label: receiver_1.Name,
                            value: receiver_1,
                        };
                    }
                }, tupledArg[1]), {
                    Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
                }));
                return {
                    label: Helper_receiverTypeNameTranslation(t, receiverType),
                    options: receivers_1,
                };
            }, List_groupBy((receiver) => receiver.ReceiverType, filter((u) => {
                if (props.WithNotification) {
                    const matchValue = u.ReceiverType;
                    switch (matchValue.tag) {
                        case 10:
                            return false;
                        case 1:
                        case 5:
                        case 8:
                        case 6:
                        case 2:
                        case 7:
                        case 3:
                        case 9:
                        case 4:
                            return u.Email != null;
                        default:
                            return true;
                    }
                }
                else {
                    return true;
                }
            }, props.Receivers), {
                Equals: equals,
                GetHashCode: (x) => (safeHash(x) | 0),
            })),
            PlaceholderKey: "select.employee_placeholder",
            Value: unwrap(props.SelectedUser),
        }))), delay(() => append_1(singleton_1(createElement(TextArea, {
            ComponentState: componentState,
            Label: t("general.comment"),
            OnChange: (arg_1) => {
                props.Dispatch(new Msg(4, [arg_1]));
            },
            TestId: "assign-tool-comment-test-id",
            Value: props.Comment,
        })), delay(() => {
            let Label_2, matchValue_2, selectedUser;
            return append_1(singleton_1(Checkbox((Label_2 = t("tool.dialog_assign_with_notification"), {
                ComponentState: (matchValue_2 = props.SelectedUser, (matchValue_2 != null) ? ((selectedUser = matchValue_2, (componentState === "enabled") ? ((equals(selectedUser.value.ReceiverType, new ReceiverTypeName(0, [])) ? true : (selectedUser.value.Email != null)) ? "enabled" : "disabled") : componentState)) : componentState),
                IsChecked: props.WithNotification,
                Label: Label_2,
                OnCheck: (arg_2) => {
                    props.Dispatch(new Msg(2, [arg_2]));
                },
                TestId: "assign-tool-dialog-with-notification-test-id",
            }))), delay(() => {
                let elems_1;
                return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [createElement(InformationAlert, {
                    Label: t("tool.dialog_assign_with_notification_info"),
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                    let Label_3, matchValue_3, selectedUser_1;
                    return append_1(singleton_1(Checkbox((Label_3 = t("tool.dialog_assign_with_signature"), {
                        ComponentState: (matchValue_3 = props.SelectedUser, (matchValue_3 != null) ? ((selectedUser_1 = matchValue_3, (componentState === "enabled") ? ((equals(selectedUser_1.value.ReceiverType, new ReceiverTypeName(0, [])) ? true : (selectedUser_1.value.Email != null)) ? "enabled" : "disabled") : componentState)) : componentState),
                        IsChecked: props.WithSignature,
                        Label: Label_3,
                        OnCheck: (arg_3) => {
                            props.Dispatch(new Msg(3, [arg_3]));
                        },
                        TestId: "assign-tool-dialog-with-notification-test-id",
                    }))), delay(() => append_1(singleton_1(createElement(DatePicker, {
                        ComponentState: componentState,
                        IsClearable: true,
                        Label: t("tool.dialog_planned_return_date"),
                        OnChange: (arg_4) => {
                            props.Dispatch(new Msg(6, [arg_4]));
                        },
                        TestId: "assign-tool-dialog-planned-return-date-test-id",
                        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "plannedReturnDate")),
                        Value: unwrap(props.Date),
                    })), delay(() => {
                        let elems_2;
                        return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems_2 = [createElement(TextValue, {
                            FontWeight: "bold",
                            TestId: "",
                            Text: t("assignment_notification.sender_images"),
                        }), createElement(ImageUpload, {
                            ComponentState: props.ImageUploading ? "disabled" : componentState,
                            SelectedFiles: props.SenderImageFiles,
                            SetSelectedFile: (files) => {
                                props.Dispatch(new Msg(17, [files]));
                            },
                        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => append_1(singleton_1(createElement(SenderHooksSection, {
                            CompletedSenderHookTemplateIds: props.CompletedSenderHookTemplateIds,
                            Dispatch: props.Dispatch,
                            FormState: props.FormState,
                            SenderHooks: props.SenderHooks,
                            TitleKey: "procedure.hooks.sender_procedures",
                        })), delay(() => {
                            let mandatoryText, options;
                            return append_1((props.WithNotification && !isEmpty(props.AssignmentHooks)) ? ((mandatoryText = t("procedure.hooks.mandatory"), (options = map((hook) => ({
                                label: hook.IsMandatory ? toText(printf("%s (%s)"))(hook.ProcedureTemplateName)(mandatoryText) : hook.ProcedureTemplateName,
                                value: hook,
                            }), props.AssignmentHooks), singleton_1(createElement(MultiSelect, {
                                ComponentState: componentState,
                                IsClearable: false,
                                Label: t("tool.dialog_assign_procedures"),
                                NoOptionsMessage: "tool.dialog_assign_procedures_no_options",
                                OnChange: (arg_7) => {
                                    props.Dispatch(new Msg(9, [arg_7]));
                                },
                                Options: options,
                                PlaceholderKey: "tool.dialog_assign_procedures_placeholder",
                                TestId: "assign-tool-procedures-select",
                                Value: props.SelectedProcedureTemplates,
                            }))))) : empty_2(), delay(() => {
                                const matchValue_4 = FormState__getValidation(props.FormState, t, "global");
                                if (matchValue_4 == null) {
                                    return empty_2();
                                }
                                else {
                                    return singleton_1(createElement(ErrorAlert, {
                                        Label: matchValue_4,
                                    }));
                                }
                            }));
                        }))));
                    }))));
                }));
            }));
        }))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export function AssignToolDialog(props) {
    let elems;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.Tool, props.UserId, props.SuccessCallback, props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    return reactElement("div", createObj(singleton((elems = toList(delay(() => {
        let matchValue_2;
        return append_1((matchValue_2 = state_1.ActiveProcedureId, (matchValue_2 == null) ? (empty_2()) : singleton_1(createElement(OpenProcedureModal, {
            IsOpen: true,
            OnCancelCallback: () => {
                dispatch(new Msg(15, []));
            },
            OnClose: () => {
                dispatch(new Msg(15, []));
            },
            OnSuccessCallback: () => {
                dispatch(new Msg(14, []));
            },
            ProcedureId: matchValue_2,
        }))), delay(() => {
            let Title, Label_1, matchValue, u, matchValue_1;
            return singleton_1(createElement(Dialog, (Title = t("tool.assign_now"), {
                Body: toList(delay(() => {
                    const matchValue_3 = state_1.Receivers;
                    const matchValue_4 = state_1.AssignmentHooks;
                    const matchValue_5 = state_1.SenderHooks;
                    let matchResult, hooks, receivers, senderHooks;
                    if (matchValue_3.tag === 1) {
                        if (matchValue_4.tag === 1) {
                            if (matchValue_5.tag === 1) {
                                matchResult = 0;
                                hooks = matchValue_4.fields[0];
                                receivers = matchValue_3.fields[0];
                                senderHooks = matchValue_5.fields[0];
                            }
                            else {
                                matchResult = 1;
                            }
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                    switch (matchResult) {
                        case 0:
                            return singleton_1(createElement(DialogBody, {
                                AssignmentHooks: hooks,
                                Comment: state_1.Comment,
                                CompletedSenderHookTemplateIds: state_1.CompletedSenderHookTemplateIds,
                                Date: unwrap(state_1.Date),
                                Dispatch: dispatch,
                                FormState: state_1.FormState,
                                ImageUploading: state_1.ImageUploading,
                                Receivers: receivers,
                                SelectedProcedureTemplates: state_1.SelectedProcedureTemplates,
                                SelectedUser: unwrap(state_1.SelectedUser),
                                SenderHooks: senderHooks,
                                SenderImageFiles: state_1.SenderImageFiles,
                                Tool: props.Tool,
                                WithNotification: state_1.WithNotification,
                                WithSignature: state_1.WithSignature,
                            }));
                        default:
                            return singleton_1(createElement(Skeleton, {
                                Variant: "normal",
                            }));
                    }
                })),
                Controls: ofArray([createElement(TextButton, {
                    ComponentState: "enabled",
                    Label: t("general.cancel"),
                    OnClick: props.OnClose,
                    TestId: "close-reservation-dialog-test-id",
                    Variant: "blueButton",
                }), createElement(TextButton, (Label_1 = t("general.save"), {
                    ComponentState: (state_1.FormState.IsLoading ? true : state_1.ImageUploading) ? "disabled" : ((((state_1.SelectedUser == null) ? true : (state_1.WithNotification && ((matchValue = state_1.SelectedUser, (matchValue == null) ? true : ((u = matchValue, (matchValue_1 = u.value.ReceiverType, (matchValue_1.tag === 10) ? false : ((matchValue_1.tag === 1) ? (u.value.Email == null) : ((matchValue_1.tag === 5) ? (u.value.Email == null) : ((matchValue_1.tag === 8) ? (u.value.Email == null) : ((matchValue_1.tag === 6) ? (u.value.Email == null) : ((matchValue_1.tag === 2) ? (u.value.Email == null) : ((matchValue_1.tag === 7) ? (u.value.Email == null) : ((matchValue_1.tag === 3) ? (u.value.Email == null) : ((matchValue_1.tag === 9) ? (u.value.Email == null) : ((matchValue_1.tag === 4) && (u.value.Email == null))))))))))))))))) ? true : hasMandatoryUncompletedSenderHooks(state_1.SenderHooks, state_1.CompletedSenderHookTemplateIds)) ? "disabled" : "enabled"),
                    Label: Label_1,
                    OnClick: () => {
                        dispatch(new Msg(1, []));
                    },
                    TestId: "save-reservation-dialog-test-id",
                    Variant: "blueButton",
                }))]),
                IsOpen: props.IsOpen,
                OnClose: props.OnClose,
                Title: Title,
            })));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

